module.exports = __webpack_public_path__ + "static/media/bestbuddynusopenhouseday.0e5f3c5f.jpeg";